var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import GenericSidebar from "@frameworks/shared-library/components/GenericSidebar";
import OrderBookSideBarHeader from "@frameworks/shared-library/components/OrderBookSideBar/OrderBookSideBarHeader";
import SideBarClientDetails from "@frameworks/shared-library/components/OrderBookSideBar/SideBarClientDetails";
import "@frameworks/shared-library/stylesheets/components/OrderBookSideBar/OrderBookSideBar.scss";
import OrderBookFooter from "@frameworks/shared-library/components/OrderBookSideBar/OrderBookFooter";
import { EOrderBookStatus, ETransactionType, EOrderbookSidebarComponents, ESidebarActioningFrom, orderBookStatusType, getStatusDescription, getNextTransactionText, getSchemeDetails, getTransactionDetailsList, getTimelineDetails, getSidebarView, footerDetails, moreDetailsCompleted, EInvestmentActionCodes, } from "@frameworks/shared-library/components/OrderBookSideBar/OrderBookSidebarConstants";
import OrderBookSideBarStatusBox from "@frameworks/shared-library/components/OrderBookSideBar/OrderBookSidebarStatusBox";
import OrderBookSideBarSchemeDetails from "@frameworks/shared-library/components/OrderBookSideBar/OrderBookSideBarSchemeDetails";
import GenericDetails from "@frameworks/shared-library/components/GenericDetails/GenericDetails";
import GenericTimeline from "@frameworks/shared-library/components/GenericTimeline/GenericTimeline";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import OrderBookSideBarPastInstallments from "@frameworks/shared-library/components/OrderBookSideBar/OrderBookSideBarPastInstallments";
import orderBookDi from "@mainDi/features/ActivityBook/OrderBook/MutualFund/servicelocator";
import Spinner from "react-bootstrap/Spinner";
import Errormsg from "@frameworks/shared-library/components/errorMsg";
import OrderBookSideBarNeedHelp, { EContactDetailsFor, } from "@frameworks/shared-library/components/OrderBookSideBar/OrderBookSideBarNeedHelp";
import { accountDetails } from "@mainDi/salesDi";
import Toasts from "@frameworks/shared-library/components/Toast/Toast";
import { capitalizeFirstLetter } from "@frameworks/salesjourney/utils/genericMethods";
import MutualFundOrderbookContext, { EKebebMenuItems, } from "@frameworks/salesjourney/components/Features/ActivityBook/RM_Orderbook/ManagePortfolio/MutualFundOrders/MutualFundOrderbookContext";
import UPI from "@frameworks/shared-library/assets/images/SalesJourney/UPI.svg";
import Edelicon from "@frameworks//web/components/generic/Edelicon";
var allPastInstallments = [];
var footerTextForPastInstallments;
var filterByOptionsForPastInstallments = [];
var initialItemsLengthForPastInstallments = 5;
var UPIIcon = React.createElement("img", { src: UPI, alt: "UPI", className: "align-self-start mx-7" });
/**
 * OrderBookSideBar
 *
 * This component is the wrapper for orderbook sidebar inidividual components for Lumpsum, Redeem, Switch, SIP, STP & SWP details
 *
 * @param {Boolean} openKey - Open or close side bar
 * @param {Function} setOpenKey - Function to control opening/closing of the sidebar
 * @param {Object} rowData - Transaction/Order details of the selected row
 * @param {Boolean} actioningFrom - Table screen from which sidebar is opened (All transaction table | SIP table | STP table | SWP table)
 * @returns {}
 */
var OrderBookSideBar = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var _p = useContext(MutualFundOrderbookContext), getCTADetailsAsPerFlags = _p.getCTADetailsAsPerFlags, handleOnClickOfAvailableCTAs = _p.handleOnClickOfAvailableCTAs;
    var _q = __read(useState(props.openKey), 2), openSideBar = _q[0], setOpenSideBar = _q[1];
    var _r = __read(useState(false), 2), openTimeline = _r[0], setOpenTimeline = _r[1];
    var _s = __read(useState([]), 2), timelineDetails = _s[0], setTimelineDetails = _s[1];
    var _t = __read(useState({
        status: [],
    }), 2), filterByForPastInstallments = _t[0], setFilterByForPastInstallments = _t[1];
    var _u = __read(useState([]), 2), pastInstallments = _u[0], setPastInstallments = _u[1];
    var _v = __read(useState(false), 2), pastInstallmentsError = _v[0], setPastInstallmentsError = _v[1];
    var _w = __read(useState({
        isShow: false,
        isError: false,
        msg: "",
    }), 2), toastDetails = _w[0], setToastDetails = _w[1];
    var _x = __read(useState(false), 2), isLoadingPastInstallments = _x[0], setIsLoadingPastInstallments = _x[1];
    var _y = __read(useState(true), 2), showLoaderOnFooter = _y[0], setShowLoaderOnFooter = _y[1];
    var _z = __read(useState([]), 2), footerCTAAvailability = _z[0], setFooterCTAAvailability = _z[1];
    var _0 = __read(useState(), 2), btnDetails = _0[0], setBtnDetails = _0[1];
    // keeping the name generic for future use
    var _1 = __read(useState(false), 2), isViewAllClicked = _1[0], setIsViewAllClicked = _1[1];
    var _2 = __read(useState(false), 2), showImage = _2[0], setShowImage = _2[1];
    var sidebarBodyRef = useRef();
    var transactionDetailsRef = useRef();
    var pastInstalmentsRef = useRef();
    // *******************************************
    // *                 Methods                *
    // *******************************************
    useEffect(function () {
        var timer;
        if (props.openKey === true && !isLoadingPastInstallments) {
            timer = setTimeout(function () {
                calculateViewBodyHeight();
            }, 30);
        }
        return function () {
            if (timer)
                clearTimeout(timer);
        };
    }, [openSideBar, isLoadingPastInstallments]);
    var calculateViewBodyHeight = function () {
        var _a, _b, _c;
        var sidebarBodyHeight = ((_a = sidebarBodyRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0;
        var pastInstalmentsHeight = ((_b = pastInstalmentsRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight) || 0;
        var transactionDetailsHeight = ((_c = transactionDetailsRef.current) === null || _c === void 0 ? void 0 : _c.offsetHeight) || 0;
        if (sidebarBodyHeight - pastInstalmentsHeight - transactionDetailsHeight >
            210)
            setShowImage(true);
    };
    var getPastDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var pastInstallmentsApiResp, err_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    // if (!/completed/i.test(props?.rowData?.txnStatus)) return;
                    if (!((_a = props === null || props === void 0 ? void 0 : props.rowData) === null || _a === void 0 ? void 0 : _a.registrationNumber))
                        return [2 /*return*/];
                    setIsLoadingPastInstallments(true);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, orderBookDi.mutualFundOrderBook.getMFOrderBookPastInstallments({
                            registrationNumber: props.rowData.registrationNumber,
                            status: [],
                        })];
                case 2:
                    pastInstallmentsApiResp = _c.sent();
                    allPastInstallments =
                        ((_b = pastInstallmentsApiResp === null || pastInstallmentsApiResp === void 0 ? void 0 : pastInstallmentsApiResp.data) === null || _b === void 0 ? void 0 : _b.length) > 0
                            ? pastInstallmentsApiResp.data
                            : [];
                    setPastInstallments(allPastInstallments.slice(0, initialItemsLengthForPastInstallments));
                    filterByOptionsForPastInstallments = [
                        { name: "Success", id: "Success" },
                        { name: "Failed", id: "Failed" },
                    ];
                    footerTextForPastInstallments = "See All Installments";
                    setPastInstallmentsError(false);
                    setIsLoadingPastInstallments(false);
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _c.sent();
                    setPastInstallmentsError(true);
                    console.log("err", err_1);
                    setIsLoadingPastInstallments(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var getMFOrderbookTimeline = function () { return __awaiter(void 0, void 0, void 0, function () {
        var request;
        var _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = {};
                    return [4 /*yield*/, accountDetails.getUserLoginType()];
                case 1:
                    _a.loginType = _c.sent();
                    return [4 /*yield*/, accountDetails.getUserLoginCode()];
                case 2:
                    request = (_a.loginCode = _c.sent(),
                        _a.trxId = (_b = props.rowData) === null || _b === void 0 ? void 0 : _b.trxId,
                        _a);
                    orderBookDi.mutualFundOrderBook
                        .getMFOrderbookTimeline(request)
                        .then(function (res) {
                        if (res) {
                            setTimelineDetails(res.data);
                        }
                    })
                        .catch(function (ex) {
                        console.log("get Timeline failed", ex);
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var computeRemarks = function () {
        var _a, _b, _c, _d;
        if (!props.rowData)
            return "";
        if (((_a = props.rowData) === null || _a === void 0 ? void 0 : _a.displayTransactionType) === ETransactionType.SIP &&
            ((_b = props.rowData) === null || _b === void 0 ? void 0 : _b.displayStatus) === EOrderBookStatus.ACTIVE &&
            ((_c = props.rowData) === null || _c === void 0 ? void 0 : _c.remarks)) {
            return capitalizeFirstLetter((_d = props === null || props === void 0 ? void 0 : props.rowData) === null || _d === void 0 ? void 0 : _d.remarks);
        }
        if (props.rowData.orderRemarks) {
            return capitalizeFirstLetter(props.rowData.orderRemarks);
        }
        // This is used to pick default values of subtext when remarks field is empty.
        return getStatusDescription(props.rowData.displayTransactionType, props.rowData.displayStatus, props.rowData.clientName);
    };
    var getStatusBoxComponent = useMemo(function () {
        var _a, _b, _c;
        if (props.rowData &&
            getSidebarView(props.rowData.displayStatus, props.rowData.displayTransactionType, props.actioningFrom, EOrderbookSidebarComponents.STATUS_BOX)) {
            var statusDescription = computeRemarks();
            var nextTxnText = [EOrderBookStatus.ACTIVE, EOrderBookStatus.PAUSE].includes(props.rowData.displayStatus) && props.rowData.invActionCode !== EInvestmentActionCodes.CANCEL
                ? getNextTransactionText(props.rowData.displayTransactionType, props.rowData.displayStatus)
                : undefined;
            var latestTxnDate = [
                EOrderBookStatus.ORDER_COMPLETED,
                EOrderBookStatus.ACTIVE,
                EOrderBookStatus.PAUSE,
            ].includes(props.rowData.displayStatus) ||
                (props.rowData.displayStatus === EOrderBookStatus.ORDER_CANCELLED &&
                    props.actioningFrom !== ESidebarActioningFrom.ALL_TRANSACTIONS_TABLE)
                ? undefined
                : (_a = props.rowData) === null || _a === void 0 ? void 0 : _a.displayTransactionTime;
            return (React.createElement(OrderBookSideBarStatusBox, { statusText: capitalizeFirstLetter(props.rowData.displayStatus), statusType: orderBookStatusType[props.rowData.displayStatus], description: statusDescription, nextTxnText: nextTxnText && ((_b = props.rowData) === null || _b === void 0 ? void 0 : _b.nextInstallmentDate) ? nextTxnText : "", nextTxnDate: nextTxnText && ((_c = props.rowData) === null || _c === void 0 ? void 0 : _c.nextInstallmentDate)
                    ? props.rowData.nextInstallmentDate
                    : "", latestTxnDate: latestTxnDate }));
        }
    }, [props.rowData]);
    var getSchemeDetailsComponent = useMemo(function () {
        if (props.rowData &&
            getSidebarView(props.rowData.displayStatus, props.rowData.displayTransactionType, props.actioningFrom, EOrderbookSidebarComponents.SCHEME_DETAILS)) {
            return (React.createElement(OrderBookSideBarSchemeDetails, { details: getSchemeDetails(props.rowData, props.actioningFrom) }));
        }
    }, [props.rowData]);
    var getTransactionDetails = useMemo(function () {
        if (props.rowData &&
            getSidebarView(props.rowData.displayStatus, props.rowData.displayTransactionType, props.actioningFrom, EOrderbookSidebarComponents.TRANSACTION_DETAILS)) {
            return (React.createElement("div", { className: "pt-20 pb-20 px-15", ref: transactionDetailsRef },
                React.createElement(GenericDetails, { details: getTransactionDetailsList(props.rowData, props.actioningFrom, UPIIcon), header: "Transaction Details" })));
        }
    }, [props.rowData]);
    var getOrderTimeline = useMemo(function () {
        var _a, _b;
        if (
        // We do not receive trxId for some type of Transactions (SIP Installement)
        // Display timeline only on All transaction tab and only for parent orders
        ((_a = props === null || props === void 0 ? void 0 : props.rowData) === null || _a === void 0 ? void 0 : _a.trxId) &&
            props.actioningFrom === ESidebarActioningFrom.ALL_TRANSACTIONS_TABLE &&
            ((_b = props === null || props === void 0 ? void 0 : props.rowData) === null || _b === void 0 ? void 0 : _b.typeOfOrder) !== "Child" &&
            getSidebarView(props.rowData.displayStatus, props.rowData.displayTransactionType, props.actioningFrom, EOrderbookSidebarComponents.ORDER_TIMELINE_DETAILS))
            return (React.createElement("div", { className: "ob-timeline-container" },
                React.createElement(EdButton, { btnTyp: "text-only", onClick: function () { return setOpenTimeline(!openTimeline); }, className: "DMSansNormal_12_400", value: React.createElement("span", { className: "d-flex align-items-center gap-1" },
                        React.createElement("span", { className: "text-decoration-underline" }, "Order Timeline"),
                        React.createElement("i", { className: openTimeline
                                ? "edel-icon-arrow-up-thin"
                                : "edel-icon-arrow-down" })) }),
                openTimeline && (React.createElement("div", { className: "ob-timeline-content" }, !Boolean(timelineDetails) ? (React.createElement(Errormsg, { icon: " ", msg: " ", customComp: React.createElement("div", { className: "error-state-button-bar flexCenter" },
                        React.createElement("p", { className: "DMSanN_14_400" }, "No Timeline data found")) })) : // If timelineDetails has content - display timeline
                    (timelineDetails === null || timelineDetails === void 0 ? void 0 : timelineDetails.length) > 0 ? (React.createElement(GenericTimeline, { timelineDetails: getTimelineDetails(timelineDetails, props.rowData.displayStatus) })) : (
                    // If get timelineDetails throw an error
                    React.createElement(Errormsg, { icon: " ", msg: "  ", customComp: React.createElement("div", { className: "error-state-button-bar flexCenter" },
                            React.createElement("p", { className: "DMSanN_14_400" }, "Try refreshing page, or try again later"),
                            React.createElement("button", { className: "align-items-center DMSanN_13_500", onClick: function () { return getMFOrderbookTimeline(); } }, "Try Again")) }))))));
    }, [props.rowData, openTimeline, timelineDetails]);
    var getInstallmentsComponent = useMemo(function () {
        if (props.rowData &&
            getSidebarView(props.rowData.displayStatus, props.rowData.displayTransactionType, props.actioningFrom, EOrderbookSidebarComponents.PAST_INSTALLMENTS)) {
            return (React.createElement(React.Fragment, null, isLoadingPastInstallments ? (React.createElement("div", { className: "d-flex justify-content-center mgt-100" },
                React.createElement(Spinner, { animation: "border", variant: "primary", className: "txt_tomatoRed" }))) : (React.createElement("div", { ref: pastInstalmentsRef },
                (allPastInstallments === null || allPastInstallments === void 0 ? void 0 : allPastInstallments.length) > 0 && (React.createElement(OrderBookSideBarPastInstallments, { filterByOptions: filterByOptionsForPastInstallments, allPastInstallments: allPastInstallments, filterBy: filterByForPastInstallments, setFilterBy: setFilterByForPastInstallments, initialItemsLengthPastInstallments: initialItemsLengthForPastInstallments, pastInstallments: pastInstallments, setPastInstallments: setPastInstallments, footerText: footerTextForPastInstallments, setIsViewAllClicked: setIsViewAllClicked, isViewAllClicked: isViewAllClicked })),
                pastInstallmentsError && (React.createElement(Errormsg, { msg: "Something went wrong", customComp: React.createElement("div", { className: "error-state-button-bar flexCenter" },
                        React.createElement("p", { className: "DMSanN_14_400" }, "Try refreshing the page, or try again later"),
                        React.createElement("button", { className: "align-items-center DMSanN_13_500", onClick: function () { return getPastDetails(); } }, "Try Again")) }))))));
        }
    }, [
        props.rowData,
        allPastInstallments,
        pastInstallments,
        filterByForPastInstallments,
        isLoadingPastInstallments,
    ]);
    var getOrderbookFooterCTAAvailability = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            getCTADetailsAsPerFlags(props === null || props === void 0 ? void 0 : props.rowData, true)
                .then(function (data) {
                setFooterCTAAvailability(data);
                setShowLoaderOnFooter(false);
            })
                .catch(function () { return setShowLoaderOnFooter(false); });
            return [2 /*return*/];
        });
    }); };
    var handleOrderbookFooterButtonAndMoreDetailsClick = function (buttonText) {
        var _a;
        if (buttonText) {
            props.setOpenKey(false);
            handleOnClickOfAvailableCTAs(buttonText, (_a = props.rowData) === null || _a === void 0 ? void 0 : _a.trxId);
        }
    };
    // *******************************************
    // *                useEffects                *
    // *******************************************
    useEffect(function () {
        var _a, _b, _c, _d;
        if (((_a = props === null || props === void 0 ? void 0 : props.rowData) === null || _a === void 0 ? void 0 : _a.displayTransactionType) &&
            ((_b = props === null || props === void 0 ? void 0 : props.rowData) === null || _b === void 0 ? void 0 : _b.displayStatus)) {
            // Get list of possible status for the particular transaction type (displayTransactionType = SIP, SWITCH, SWP_INSTALLMENT etc)
            var listOfButtonByTrxType = footerDetails[(_c = props.rowData) === null || _c === void 0 ? void 0 : _c.displayTransactionType];
            // Get list of possible buttons for the particular Order status (displayStatus = CONSENT_PENDING, ACTIVE etc)
            var buttonDetails_1 = listOfButtonByTrxType === null || listOfButtonByTrxType === void 0 ? void 0 : listOfButtonByTrxType[props.rowData.displayStatus];
            if (props.rowData.displayStatus === EOrderBookStatus.ORDER_COMPLETED &&
                !props.rowData.fromAllTransactions &&
                (props.rowData.displayTransactionType === ETransactionType.STP ||
                    props.rowData.displayTransactionType === ETransactionType.SWP)) {
                buttonDetails_1 = {
                    label: EKebebMenuItems.DUPLICATE,
                    moreDetails: moreDetailsCompleted,
                };
            }
            // buttonDetail: Possible button available for the selected transaction type based on Order status
            // footerCTAAvailability: List of dynamic flags which informs whether the CTA is available or not (these flags are based on scheme to client combination - login implemented on Database side )
            if (buttonDetails_1 && footerCTAAvailability.length > 0) {
                var primaryCta = footerCTAAvailability[0];
                footerCTAAvailability.splice(0, 1);
                // const footerCTAAvailabilityButtonLabels = footerCTAAvailability?.map(
                //   (item) => item.text
                // );
                // 3dots menu CTAs = All the available CTAs except the primary CTA, View details and View transaction
                var filteredMoreDetails = footerCTAAvailability.filter(function (item) {
                    return item.text !== buttonDetails_1.label &&
                        item.text !== EKebebMenuItems.VIEW_DETAILS &&
                        item.text !== EKebebMenuItems.VIEW_TRANSACTION;
                });
                // check if the button is available based on the dynamic flags
                // const isFooterButtonAvailable =
                //   footerCTAAvailabilityButtonLabels.includes(buttonDetails.label);
                var key = (_d = primaryCta === null || primaryCta === void 0 ? void 0 : primaryCta.text) === null || _d === void 0 ? void 0 : _d.toUpperCase();
                var value = void 0;
                if (key in EKebebMenuItems) {
                    value = EKebebMenuItems[key];
                }
                buttonDetails_1.label = primaryCta
                    ? value
                    : EKebebMenuItems.EXPLORE_OTHER_FUNDS;
                buttonDetails_1.moreDetails = filteredMoreDetails;
                setBtnDetails(buttonDetails_1);
            }
            else {
                // If no CTA is available for any transaction type and Order status
                buttonDetails_1 = {
                    label: EKebebMenuItems.EXPLORE_OTHER_FUNDS,
                    moreDetails: [],
                };
                setBtnDetails(buttonDetails_1);
            }
        }
    }, [props === null || props === void 0 ? void 0 : props.rowData, footerCTAAvailability]);
    useEffect(function () {
        setOpenSideBar(props.openKey);
    }, [props.openKey]);
    useEffect(function () {
        if (getSidebarView(props.rowData.displayStatus, props.rowData.displayTransactionType, props.actioningFrom, EOrderbookSidebarComponents.ORDER_TIMELINE_DETAILS)) {
            getMFOrderbookTimeline();
        }
        if (getSidebarView(props.rowData.displayStatus, props.rowData.displayTransactionType, props.actioningFrom, EOrderbookSidebarComponents.PAST_INSTALLMENTS)) {
            getPastDetails();
        }
        getOrderbookFooterCTAAvailability();
    }, []);
    // *******************************************
    // *                Rendering                *
    // *******************************************
    return (Object.values(EOrderBookStatus).includes((_a = props === null || props === void 0 ? void 0 : props.rowData) === null || _a === void 0 ? void 0 : _a.displayStatus) && (React.createElement(React.Fragment, null,
        React.createElement(GenericSidebar, { parentClassname: "primary-order-book-sidebar-container", header: React.createElement("div", null,
                React.createElement(OrderBookSideBarHeader, { defaultOpen: true, schemeDetails: {
                        schemeName: (_b = props.rowData) === null || _b === void 0 ? void 0 : _b.scheme.isinName,
                        catName: (_c = props.rowData) === null || _c === void 0 ? void 0 : _c.scheme.catName,
                        subCatName: (_d = props.rowData) === null || _d === void 0 ? void 0 : _d.scheme.subCatName,
                        amcLogo: (_f = (_e = props.rowData) === null || _e === void 0 ? void 0 : _e.scheme) === null || _f === void 0 ? void 0 : _f.amcLogo,
                    }, toSchemeDetails: Boolean((_g = props.rowData) === null || _g === void 0 ? void 0 : _g.toScheme) && {
                        schemeName: (_h = props.rowData) === null || _h === void 0 ? void 0 : _h.toScheme.isinName,
                        catName: (_j = props.rowData) === null || _j === void 0 ? void 0 : _j.toScheme.catName,
                        subCatName: (_k = props.rowData) === null || _k === void 0 ? void 0 : _k.toScheme.subCatName,
                        amcLogo: (_m = (_l = props.rowData) === null || _l === void 0 ? void 0 : _l.toScheme) === null || _m === void 0 ? void 0 : _m.amcLogo,
                    }, trxType: props.rowData.displayTransactionType })), body: React.createElement(React.Fragment, null,
                toastDetails && (React.createElement(Toasts, { show: toastDetails.isShow, setShow: function (val) {
                        setToastDetails({ isShow: val, isError: false, msg: "" });
                    }, position: "bottom-center", message: toastDetails.msg, delay: 3000, parentClass: "sidebar-toast-container ".concat(toastDetails.isError ? "" : "success-toast") })),
                React.createElement(SideBarClientDetails, { clientCode: props.rowData.clientCode, pan: props.rowData.pan, clientName: props.rowData.clientName, uniqueClientId: props.rowData.ucc, clientTier: (_o = props.rowData) === null || _o === void 0 ? void 0 : _o.clientTier, tooltipPlacement: "bottom" }),
                React.createElement("div", { className: "bg_aqua_white order-book-sidebar-body d-flex flex-column ".concat(props.rowData.displayTransactionType ===
                        ETransactionType.SWITCH ||
                        props.rowData.displayTransactionType === ETransactionType.STP
                        ? showLoaderOnFooter || btnDetails
                            ? "body-h-double-header-with-footer"
                            : "body-h-double-header"
                        : showLoaderOnFooter || btnDetails
                            ? "body-h-single-header-with-footer"
                            : "body-h-single-header") },
                    React.createElement("div", { className: "sidebar-body-top-container" },
                        getStatusBoxComponent,
                        getSchemeDetailsComponent,
                        getOrderTimeline),
                    React.createElement("div", { className: "sidebar-body-mid-container", ref: sidebarBodyRef },
                        getTransactionDetails,
                        getInstallmentsComponent,
                        showImage && (React.createElement("div", { className: "d-flex justify-content-end pt-10 position-static side-txn-bg-image-container" },
                            React.createElement(Edelicon, { className: "edel-icon-save-money-hand2", paths: 80 })))),
                    React.createElement(OrderBookSideBarNeedHelp, { clientCode: props.rowData.clientCode, contactDetailsFor: EContactDetailsFor.helpDesk }))), footer: showLoaderOnFooter ? (React.createElement("div", { className: "d-flex align-items-center w-100 justify-content-center" },
                React.createElement(Spinner, { animation: "border", variant: "primary" }))) : btnDetails ? (React.createElement(OrderBookFooter, { btnDetails: btnDetails, handleOrderbookFooterCTAClick: handleOrderbookFooterButtonAndMoreDetailsClick })) : undefined, openKey: openSideBar, setOpenKey: props.setOpenKey, arrowClose: true, delay: 10, blurBackground: true }))));
};
export default OrderBookSideBar;
